/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum NotificationDialogsTextKeys {
    Ok = 'Ok',
    Yes = 'Yes',
    No = 'No',
    Cancel = 'Cancel',
    Close = 'Close',
}
